module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "news_sub"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "tea_r_l"
  }, [_c('div', {
    staticClass: "tx18"
  }, [_vm._v(_vm._s(_vm.news.title))])]), _vm._v(" "), _c('div', {
    staticClass: "tea_r_r"
  }, [_c('div', {
    staticClass: "tx18"
  }, [_vm._v(_vm._s(_vm.news.createdAt && _vm.news.createdAt.split(' ')[0]))])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "team_bbox",
    domProps: {
      "innerHTML": _vm._s((_vm.news.context))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_r_l"
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_r_r"
  }, [_c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.backname))])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.attachPicture))]), _vm._v(" "), _vm._l((_vm.news.pictures), function(picture, index) {
    return _c('div', {
      key: 'i' + index
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "margin": "25px"
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "width": "212",
        "src": picture.file_url
      },
      on: {
        "click": function($event) {
          _vm.showPicture(picture.file_url)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.attachFile))]), _vm._v(" "), _vm._l((_vm.news.files), function(file, index) {
    return _c('div', {
      key: 'f' + index
    }, [_c('a', {
      attrs: {
        "href": file.file_url,
        "download": ""
      }
    }, [_vm._v(_vm._s(file.file_name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 2)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "pictureModal"
    },
    model: {
      value: (_vm.pictureModal),
      callback: function($$v) {
        _vm.pictureModal = $$v
      },
      expression: "pictureModal"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eca9da6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NewsSub.vue
// module id = 1219
// module chunks = 4